export enum ErrorType {
  obligatory = 'obligatory',
  tooLong = 'tooLong',
  tooShort = 'tooShort',
  unCorrect = 'unCorrect',
  info = 'info'
}

export type Args = {
  maxLength?: number;
  minLength?: number;
  customValidation?: (...values: string[]) => boolean;
  value: any;
  required?: boolean;
};

export const CheckInputValueValidity = ({ maxLength, minLength, customValidation, value, required }: Args) => {
  const valueLength = typeof value === 'number' ? value : value.length;
  if (required && value.length === 0) {
    return {
      error: true,
      messageType: ErrorType.obligatory
    };
  }
  if (minLength && valueLength < minLength) {
    return {
      error: true,
      messageType: ErrorType.tooShort
    };
  } else if (maxLength && valueLength > maxLength) {
    return {
      error: true,
      messageType: ErrorType.tooLong
    };
  } else if (value.length > 0 && customValidation && !customValidation(value)) {
    return {
      error: true,
      messageType: ErrorType.unCorrect
    };
  } else {
    return {
      error: false,
      messageType: ErrorType.info
    };
  }
};
